import React from "react";

const InternationalAffairs = () => {
  return (
    <div className="bg-emerald-50 text-gray-800 overflow-hidden">

      {/* ================= HERO SECTION ================= */}
      <section className="relative bg-gradient-to-br from-emerald-800 to-emerald-900 text-white">
        {/* SVG HEADER */}
        <svg
          className="absolute bottom-0 left-0 w-full"
          viewBox="0 0 1440 120"
          preserveAspectRatio="none"
        >
          <path
            d="M0,80 C240,120 480,20 720,30 960,40 1200,100 1440,60 L1440,0 L0,0 Z"
            fill="#388E3C"
          />
        </svg>

        <div className="relative max-w-7xl mx-auto px-6 py-24 text-center">
          <img
            src="/assets/img/bubbanlogo.jpg"
            alt="Bandarban University"
            className="w-28 h-28 mx-auto mb-6 drop-shadow-xl animate-bounce"
          />

          <h1 className="text-4xl md:text-5xl font-extrabold tracking-wide">
            Office of International Affairs
          </h1>
          <p className="mt-3 text-lg text-emerald-100">
            Bandarban University
          </p>
        </div>
      </section>

      {/* ================= ABOUT ================= */}
      <section className="max-w-6xl mx-auto px-6 py-16">
        <h2 className="text-3xl font-bold text-emerald-800 text-center mb-6">
          About Us
        </h2>
        <p className="text-center leading-8 max-w-4xl mx-auto">
          The Office of International Affairs (OIA) at Bandarban University
          promotes internationalization, global engagement, and cross-cultural
          collaboration. It serves as the central hub for building partnerships
          with foreign universities, managing international programs, supporting
          international students and faculty, and facilitating academic mobility.
        </p>
      </section>

      {/* ================= VISION & MISSION ================= */}
      <section className="bg-white py-16">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-8">
          <div className="bg-emerald-50 p-8 rounded-xl shadow-lg hover:-translate-y-2 transition">
            <h3 className="text-2xl font-semibold text-emerald-800 mb-4">
              Vision
            </h3>
            <p>
              To establish Bandarban University as a globally recognized
              institution by fostering meaningful international partnerships,
              promoting cultural exchange, and empowering students and faculty
              to thrive globally.
            </p>
          </div>

          <div className="bg-emerald-50 p-8 rounded-xl shadow-lg hover:-translate-y-2 transition">
            <h3 className="text-2xl font-semibold text-emerald-800 mb-4">
              Mission
            </h3>
            <ul className="list-disc pl-5 space-y-2">
              <li>Promote international teaching and research collaboration</li>
              <li>Facilitate student and faculty exchange programs</li>
              <li>Support international students</li>
              <li>Encourage global exposure</li>
              <li>Enhance global academic reputation</li>
            </ul>
          </div>
        </div>
      </section>

      {/* ================= OBJECTIVES ================= */}
      <section className="max-w-6xl mx-auto px-6 py-16">
        <h2 className="text-3xl font-bold text-center text-emerald-800 mb-10">
          Core Objectives
        </h2>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6">
          {[
            "Develop MoUs with international universities",
            "Coordinate global workshops & conferences",
            "Support student mobility & internships",
            "Assist faculty research collaboration",
            "Promote cultural diplomacy",
          ].map((item, index) => (
            <div
              key={index}
              className="bg-white p-6 rounded-lg shadow-md border-l-4 border-yellow-400 hover:shadow-xl hover:-translate-y-1 transition"
            >
              {item}
            </div>
          ))}
        </div>
      </section>

      {/* ================= SERVICES ================= */}
      <section className="bg-white py-16">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-10">
          <div>
            <h3 className="text-2xl font-semibold text-emerald-800 mb-4">
              For Students
            </h3>
            <ul className="list-disc pl-5 space-y-2">
              <li>Exchange programs</li>
              <li>Study abroad guidance</li>
              <li>Scholarships information</li>
              <li>Visa support</li>
            </ul>
          </div>

          <div>
            <h3 className="text-2xl font-semibold text-emerald-800 mb-4">
              For Faculty
            </h3>
            <ul className="list-disc pl-5 space-y-2">
              <li>Research collaboration</li>
              <li>Joint publications</li>
              <li>Visiting scholar programs</li>
            </ul>
          </div>
        </div>
      </section>

      {/* ================= CONTACT ================= */}
      <section className="bg-gradient-to-r from-emerald-800 to-emerald-900 text-white py-16">
        <div className="max-w-5xl mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold mb-6">
            Contact Information
          </h2>

          <p className="mb-4">
            <strong>Office of International Affairs</strong><br />
            Bandarban University
          </p>

          <p className="mb-6">
            📧 international.affairs@bu.edu.bd
          </p>

          <div className="bg-white/10 rounded-xl p-6 inline-block">
            <p className="font-semibold">Coordinator</p>
            <p>MD Tahidul Islam Masum</p>
            <p className="text-sm mt-1">
              📧 masum.int_affairs@bu.edu.bd
            </p>
            <p className="text-sm">
              ☎ +880 1818-266226
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default InternationalAffairs;
